import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeatureSection from './components/FeatureSection';
import TrustSection from './components/TrustSection';
import ComparisonTable from './components/ComparisonTable';
import ArticleGrid from './components/ArticleGrid';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';
import { buildWebSiteJsonLd, buildOrganizationJsonLd, buildBreadcrumbJsonLd, SITE_URL } from '@/utils/jsonld';

const webSiteJsonLd = buildWebSiteJsonLd();
const orgJsonLd = buildOrganizationJsonLd();
const breadcrumbJsonLd = buildBreadcrumbJsonLd([{ name: 'Home', url: SITE_URL }]);

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <FeatureSection />
        <TrustSection />
        <ComparisonTable />
        <ArticleGrid />
        <CTASection />
        <Testimonials />
      </main>
      <Footer />
    </>
  );
}